<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                <div class="laporan-periode">
                    <h4>Laporan Gadai Baru</h4>
                    <h6>
                        Periode : 
                        <span>{{$helper.changeDateFormat(periodeStart)}}</span>
                        <span v-if="periodeEnd != ''"> - {{$helper.changeDateFormat(periodeEnd)}}</span>
                    </h6>
                </div>
                <b-button variant="pgiBtn" class="mb-0 download-btn" @click="openModalDownload()">
                    <!-- <a v-bind:href="$baseFilePath + filePath" target="_blank">
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a> -->
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
            <b-row>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-laptop"></i>
                                <strong>{{dataGadaiCabangAll.jumlahElek}}</strong>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Gadai Elektronik</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataGadaiCabangAll.nominalElek)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-book"></i>
                                <strong>{{dataGadaiCabangAll.jumlahBpkb}}</strong>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Gadai BPKB</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataGadaiCabangAll.nominalBpkb)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-car"></i>
                                <strong>{{dataGadaiCabangAll.jumlahKend}}</strong>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Gadai Kendaraan</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataGadaiCabangAll.nominalKend)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-card >
                <template v-slot:header>
                    <h5>Laporan Gadai Cabang</h5>
                </template>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >   
                        <div class="d-flex search-input-wrapper">
                            <multiselect
                                class="ml-2 mr-2"
                                name="filterCabang"
                                v-model="input.filterCabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih filter cabang --"
                            />
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="dataGadaiCabang" 
                    :fields="fields" 
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data gadai baru.
                    </template>
                    <template v-slot:thead-top>
                        <b-tr>
                            <b-th># </b-th>
                            <b-th colspan="2">Elektronik</b-th>
                            <b-th colspan="2">BPKB</b-th>
                            <b-th colspan="2">Kendaraan</b-th>
                        </b-tr>
                    </template>
                    <template v-slot:cell(jumlahElek)="row">
                        <div class="text-right no-wrap">
                            {{ row.item.jumlahElek }}                 
                        </div>
                    </template>
                    <template v-slot:cell(jumlahKend)="row">
                        <div class="text-right no-wrap">
                            {{ row.item.jumlahKend }}                 
                        </div>
                    </template>
                    <template v-slot:cell(jumlahBpkb)="row">
                        <div class="text-right no-wrap">
                            {{ row.item.jumlahBpkb }}                 
                        </div>
                    </template>
                    <template v-slot:cell(nominalElek)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalElek == null">{{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.nominalElek < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalElek).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalElek)}} </div>
                    </template>
                    <template v-slot:cell(nominalKend)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalKend == null">{{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.nominalKend < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalKend).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalKend)}} </div>
                    </template>
                    <template v-slot:cell(nominalBpkb)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalBpkb == null">{{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.nominalBpkb < 0">- Rp{{$helper.addThousandSeparator(row.item.nominalBpkb).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalBpkb)}} </div>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </b-card>
        </div>
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadLink == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-laporan-gadai-baru',
    data() {
        return {
            initStatus: 1,
            isBusy: true,
            input:{
                show: 10,
                filterCabang: null,
            },
            fields: [
                { key: "cabangName", label: "Cabang", sortable: true },
                { key: "jumlahElek", label: "Jumlah", sortable: true },
                { key: "nominalElek", label: "Nominal", sortable: true },
                { key: "jumlahBpkb", label: "Jumlah", sortable: true },
                { key: "nominalBpkb", label: "Nominal", sortable: true },
                { key: "jumlahKend", label: "Jumlah", sortable: true },
                { key: "nominalKend", label: "Nominal", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataGadaiCabangAll : [],
            dataGadaiCabang: [],
            filePath: "",
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            id: '',
            periodeStart: '',
            periodeEnd: '',
            isLoadLink: false,
            filePathDownload: ""
        }
    }, 
    methods: {
        
        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show

            this.id = this.$route.params.id

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getDataGadaiBaru = this.$axios.get(`laporan-eksekutif/gadai-baru/?${this.id}`).then(response => {
                this.dataGadaiCabangAll = response.data
                this.dataGadaiCabang = response.data.entries
                this.updateTotalItem()
              
            })

            Promise.all([getCabang, getDataGadaiBaru]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
                this.periodeStart = this.id.slice(10, 20)
                if(this.id.length > 21){
                    this.periodeEnd = this.id.slice(29)
                }
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataGadaiBaru(){
            this.dataGadaiCabang = this.dataGadaiCabangAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataGadaiBaru()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.dataGadaiCabangAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.dataGadaiCabang = filteredArray
                this.onFiltered(this.dataGadaiCabang)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.dataGadaiCabang.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        openModalDownload(){

            this.isLoadLink = true

            this.$axios.get(`laporan-eksekutif/gadai-baru/dl/?${this.id}`).then(response => {
                
                this.$bvModal.show('modal-download-excel')
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadLink = false
            })
        }
    },
    created() {
        this.init()
    }
}
</script>
